var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 9.33333C10.6666 9.88559 11.1144 10.3333 11.6666 10.3333C12.2189 10.3333 12.6666 9.88559 12.6666 9.33333C12.6666 8.78106 12.2189 8.33333 11.6666 8.33333C11.1144 8.33333 10.6666 8.78106 10.6666 9.33333Z",
    stroke: "#00deff",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66671 4.66667H10.6667C12.5523 4.66667 13.4951 4.66667 14.0809 5.25245C14.6667 5.83824 14.6667 6.78107 14.6667 8.66667V10C14.6667 11.8856 14.6667 12.8284 14.0809 13.4142C13.4951 14 12.5523 14 10.6667 14H6.66671C4.15255 14 2.89547 14 2.11442 13.2189C1.33337 12.4379 1.33337 11.1808 1.33337 8.66667V7.33333C1.33337 4.81917 1.33337 3.5621 2.11442 2.78105C2.89547 2 4.15255 2 6.66671 2H9.33337C9.95337 2 10.2634 2 10.5177 2.06815C11.2078 2.25308 11.747 2.79218 11.9319 3.48236C12 3.73669 12 4.04669 12 4.66667",
    stroke: "#00deff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon2);
export default __webpack_public_path__ + "static/media/walletIcon2.699aed57e348203a7ff2281144f7e94c.svg";
export { ForwardRef as ReactComponent };